export class AsyncLock {
    constructor() {
        this._promise = Promise.resolve();
        this._disable = () => { };
    }
    Lock() {
        this._promise = new Promise(resolve => this._disable = resolve);
    }
    Unlock() {
        this._disable();
    }
    WaitForLockAsync() {
        return this._promise;
    }
}
//# sourceMappingURL=AsyncLock.js.map